import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { taxExportMonth, socialExportMonth, taxGetMonthList, SocialGetMonthList, staffInfoList, staffInfoExcel, downloadPdf as _downloadPdf, downloadTawiPdf, downloadMonthTxt, downloadPNDTxt, downloadKorTxt, downloadKorPdf, exportMonth, getMonthList, getPnd3MonthList, exportPnd3Excel, downloadPnd3PDF, downloadPnd3TXT } from 'api/payroll/prove-download';
import Dep from '@/components/department';
// 根据类型请求不同的接口
var requestMaps = new Map([[1, {
  excel: socialExportMonth,
  list: SocialGetMonthList
}], [2, {
  excel: taxExportMonth,
  list: taxGetMonthList
}], [3, {
  excel: staffInfoExcel,
  list: staffInfoList
}], [4, {
  excel: exportMonth,
  list: getMonthList
}],
// 新增PDN3接口映射
[8, {
  excel: exportPnd3Excel,
  list: getPnd3MonthList
}]]);
var images = [require('@/assets/img/Chinese.png'), require('@/assets/img/en.png'), require('@/assets/img/th.png')];
export default {
  components: {
    Dep: Dep
  },
  props: {
    /**
     *  @description
     *  1 SorPorSor
     *  2 PND.1
     *  3 员工信息表
     *  4 Provident Fund Report
     *  5 withholding tax certificate（50 Tawi)
     *  6 PND1 Kor
     *  7 员工证明
     *  8 PND3
     */
    type: {
      default: false
    }
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear() - 1;
        }
      },
      form: {
        year: this.type === 5 || this.type === 6 ? (new Date().getFullYear() - 1).toString() : '',
        month: '',
        dept_id: ''
      },
      tableData: [],
      tableColumn: [],
      dialogVisible: false,
      images: images
    };
  },
  computed: {
    requestData: function requestData() {
      return requestMaps.get(Number(this.type));
    },
    disabled: function disabled() {
      var _this$form = this.form,
        year = _this$form.year,
        month = _this$form.month;
      return Boolean(this.type === 3 ? year : month);
    },
    disBtn: function disBtn() {
      var _this$form2 = this.form,
        month = _this$form2.month,
        year = _this$form2.year;
      if ([5, 6].includes(this.type)) {
        return !year;
      }
      return [1, 2, 8].includes(this.type) && !month;
    },
    isPND3: function isPND3() {
      return this.type === 8;
    }
  },
  methods: {
    search: function search() {
      var _this = this;
      var _this$form3 = this.form,
        year = _this$form3.year,
        month = _this$form3.month,
        dept_id = _this$form3.dept_id;
      var msg = {
        year: month ? month.split('-')[0] : year,
        dept_id: dept_id,
        month: month
      };
      this.requestData.list(this.isPND3 ? month : msg).then(function (res) {
        _this.tableColumn = res.data.header;
        _this.tableData = res.data.body;
      });
    },
    // 下载
    download: function download() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$form, year, month, dept_id, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2$form = _this2.form, year = _this2$form.year, month = _this2$form.month, dept_id = _this2$form.dept_id;
              _context.next = 3;
              return _this2.requestData.excel(_this2.isPND3 ? month : {
                month: month,
                year: year,
                dept_id: dept_id
              });
            case 3:
              res = _context.sent;
              window.location.href = res.data.down_load_excel.object_url;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    changeDep: function changeDep(a) {
      this.form.dept_id = a[0] && a[0].department_id;
    },
    // 下载PDF
    downloadPdf: function downloadPdf(type) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res, _res2, _res3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(type === 5)) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return downloadTawiPdf({
                year: _this3.form.year
              });
            case 3:
              res = _context2.sent;
              if (res.code === 1) _this3.$message.success(res.message);
            case 5:
              if (!(type === 2)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 8;
              return _downloadPdf({
                month: _this3.form.month
              });
            case 8:
              _res = _context2.sent;
              if (_res.code === 1) _this3.$message.success(_res.message);
            case 10:
              if (!(type === 6)) {
                _context2.next = 15;
                break;
              }
              _context2.next = 13;
              return downloadKorPdf({
                year: _this3.form.year
              });
            case 13:
              _res2 = _context2.sent;
              if (_res2.code === 1) _this3.$message.success(_res2.message);
            case 15:
              if (!_this3.isPND3) {
                _context2.next = 20;
                break;
              }
              _context2.next = 18;
              return downloadPnd3PDF(_this3.form.month);
            case 18:
              _res3 = _context2.sent;
              if (_res3.code === 1) _this3.$message.success(_res3.message);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 下载 TXT
    downloadTxt: function downloadTxt(type) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, _res4, _res5, _res6;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(type === 1)) {
                _context3.next = 9;
                break;
              }
              if (!_this4.form.month) {
                _context3.next = 8;
                break;
              }
              _context3.next = 4;
              return downloadMonthTxt({
                month: _this4.form.month
              });
            case 4:
              res = _context3.sent;
              if (res.code === 1) {
                _this4.$message.success(res.message);
                window.location.href = res.data.object_url;
              }
              _context3.next = 9;
              break;
            case 8:
              _this4.$message.warning(_this4.$t('txt_info'));
            case 9:
              if (!(type === 2)) {
                _context3.next = 18;
                break;
              }
              if (!_this4.form.month) {
                _context3.next = 17;
                break;
              }
              _context3.next = 13;
              return downloadPNDTxt({
                month: _this4.form.month
              });
            case 13:
              _res4 = _context3.sent;
              if (_res4.code === 1) {
                _this4.$message.success(_res4.message);
                window.location.href = _res4.data.object_url;
              }
              _context3.next = 18;
              break;
            case 17:
              _this4.$message.warning(_this4.$t('txt_info'));
            case 18:
              if (!(type === 6)) {
                _context3.next = 27;
                break;
              }
              if (!_this4.form.year) {
                _context3.next = 26;
                break;
              }
              _context3.next = 22;
              return downloadKorTxt({
                year: _this4.form.year
              });
            case 22:
              _res5 = _context3.sent;
              if (_res5.code === 1) {
                _this4.$message.success(_res5.message);
                window.location.href = _res5.data.object_url;
              }
              _context3.next = 27;
              break;
            case 26:
              _this4.$message.warning(_this4.$t('txt_info'));
            case 27:
              if (!_this4.isPND3) {
                _context3.next = 36;
                break;
              }
              if (!_this4.form.month) {
                _context3.next = 35;
                break;
              }
              _context3.next = 31;
              return downloadPnd3TXT(_this4.form.month);
            case 31:
              _res6 = _context3.sent;
              if (_res6.code === 1) {
                _this4.$message.success(_res6.message);
                window.location.href = _res6.data.object_url;
              }
              _context3.next = 36;
              break;
            case 35:
              _this4.$message.warning(_this4.$t('txt_info'));
            case 36:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};